import request from "@/common/request"
import { DetalhamentoDaReservaDoProduto, Estoque, EstoqueEmGrade, EstoqueProjection, FiltroDeMovimentacaoDeEstoque, ListagemDeMovimentacaoDeEstoque, ListagemDeMovimentacaoSintetica, Page, ProdutoVitrineVirtual, TipoDeBuscaDaVitrineVirtual } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/estoques'

export const findEstoques = (params?: any, config?: AxiosRequestConfig): Promise<Page<Estoque>> =>
	request.get(`${basePath}`, {
		params: {
			...params,
		},
		...config,
	})

export const findOtimizado = (params?: any, config?: AxiosRequestConfig): Promise<Page<EstoqueProjection>> =>
	request.get(`${basePath}/lista`, {
		params,
		...config,
	})


export const salvarRomaneio = async (

): Promise<any> => 
	request.post("/romaneio")

export const findEstoqueEmGradePorProduto = async (params?: any, config?: AxiosRequestConfig): Promise<EstoqueEmGrade> =>
	request.get(`${basePath}/grade`, {
		params,
		...config,
	})

export const findMovimentacaoAnalitica = async (filtro: FiltroDeMovimentacaoDeEstoque, config?: AxiosRequestConfig): Promise<Page<ListagemDeMovimentacaoDeEstoque>> =>
	request.get(`${basePath}/listagemDeMovimentacaoAnalitica`, {
		params: {...filtro, ...config},
	})

export const findMovimentacaoSintetica = async (filtro: FiltroDeMovimentacaoDeEstoque, config?: AxiosRequestConfig): Promise<Page<ListagemDeMovimentacaoSintetica>> =>
	request.get(`${basePath}/listagemDeMovimentacaoSintetica`, {
		params: {...filtro, ...config},
	})

export interface GrupoResumoMovimentacao {
	categoria: string
	sentido: 'ENTRADA' | 'SAIDA' | 'RESERVA'
	quantidade: number
}

export interface LinhaExtratoMovimentacao {
	data: string
	categoria: string
	sentido: 'ENTRADA' | 'SAIDA'
	quantidade: number
	saldoApos: number
	documento: string | null
}

export interface ResumoMovimentacaoEstoque {
	saldoInicial: number
	saldoFinal: number
	totalEntradas: number
	totalSaidas: number
	reservadoFinal: number
	disponivelFinal: number
	grupos: GrupoResumoMovimentacao[]
	extrato: LinhaExtratoMovimentacao[]
}

export const findResumoMovimentacao = async (filtro: any, config?: AxiosRequestConfig): Promise<ResumoMovimentacaoEstoque> =>
	request.get(`${basePath}/resumoDeMovimentacao`, {
		params: filtro,
		...config,
	})

export const findDetalhamento = async (params: any, config?: AxiosRequestConfig): Promise<Page<DetalhamentoDaReservaDoProduto>> =>
	request.get(`${basePath}/detalhamento-da-reserva-do-produto`, {params: {...params, ...config} })

export const findMovimentacaoAnaliticaCompleta = async (filtro: FiltroDeMovimentacaoDeEstoque, config?: AxiosRequestConfig): Promise<any> =>
	request.get(`${basePath}/listagemDeMovimentacaoAnalitica/completo`, {
		params: {...filtro, ...config},
	})

export const consultaEstoqueDaVitrineVirtual = async (lojaId: string, codigo: string, tipoDeBusca: TipoDeBuscaDaVitrineVirtual): Promise<ProdutoVitrineVirtual[]> =>
	request.get(`${basePath}/vitrine-virtual/${lojaId}`, {
		params: { codigo, tipoDeBusca },
	})

export const buscarSkusSemEstoqueNaVitrineVirtual = async (lojaId: string, quantidadePorSku: Record<string, number>): Promise<string[]> =>
	request.post(`${basePath}/vitrine-virtual/disponivel/${lojaId}`, quantidadePorSku)